// extracted by mini-css-extract-plugin
export default {"container":"task-logs-page-section_container__RaBmA","headerContainer":"task-logs-page-section_headerContainer__m2flV"};